import React, {useState} from "react";
import FilterMobileHeaderComponent from "@/components/ui/mobile-filter/filter-mobile-header-component";
import {useToggleFilterStore} from "@/store/catalog-filter/toggle-filter-store";
import {useRouter} from "next/navigation";
import FilterButtons from "@/components/ui/sidebar/filter-sidebar/filter-buttons";
import FilterSidebar from "@/components/ui/sidebar/filter-sidebar/filter-slider";
import LargeButton from "@/components/global/buttons/large-button";
import { AttributeOptionsTitleListType, QueryParamsSearch, VariationOptionsTitleListType } from "@/types/api/search";

interface FilterMobileComponent {
    searchParamsValues: QueryParamsSearch , 
    variationOptionsTitleList: VariationOptionsTitleListType[],
    attributeOptionsTitleList: AttributeOptionsTitleListType[]
}

const FilterMobileComponent = ({searchParamsValues , variationOptionsTitleList , attributeOptionsTitleList}: FilterMobileComponent) => {
    const {open, setOpen} = useToggleFilterStore();
    const router = useRouter();
    const [pageFilterStatus, setPageFilterStatus] = useState<"brand-filter" | "price-range" | "filter-option">("filter-option");
    const [selectedFilters, setSelectedFilters] = useState<{ label: string; value: string }[]>([]);

    const clearFilters = () => {
        router.push("?");
        setOpen(false);
    };

    return (
        <>
            {open && (
                <section className="w-full h-[100vh] menu-show-anime z-[100] fixed top-0 left-0 bg-white flex flex-col">
                    <FilterMobileHeaderComponent
                        clearFilters={clearFilters}
                        selectedFilters={selectedFilters}
                        pageFilterStatus={pageFilterStatus}
                        setPageFilterStatus={setPageFilterStatus}
                    />

                    <div className={"w-full flex px-0 flex-wrap"}>
                        <FilterButtons searchParams={searchParamsValues}/>
                    </div>

                    <div className={"w-full px-4 h-screen overflow-y-auto"}>
                        <FilterSidebar
                            variationOptionsTitleList={variationOptionsTitleList}
                            attributeOptionsTitleList={attributeOptionsTitleList}
                        />
                    </div>
                    <div className={"w-full h-20  shadow-top bg-white p-3 flex items-center justify-center "}>
                        <LargeButton onClick={() => setOpen(false)} title={"اعمال فیلتر"} variant={"default"} customClass={"!border-0 h-12"}/>
                    </div>

                </section>
            )}
        </>
    );
};

export default FilterMobileComponent;
